import { DateTime } from 'luxon';

export default function isSameMonth(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;
  
  
  // Compare least significant, most likely to change units first
  return a.month === b.month && a.year === b.year;
}
